import index from './link'

export default index